import actionTypes from '../actions/actionTypes'

const defaultState = {}

function addNewSlideData(state, action) {
	return {
		...state,
		[action.payload.id]: action.payload,
	}
}

const slidesReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.GAME_INITIALIZE_SLIDE_DATA_SUCCESS:
			return addNewSlideData(state, action)
		default:
			return state
	}
}

export default slidesReducer
